import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 消息通知列表（分页）
  mobilemsgpage(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/receive/page',
      method: 'post',
      data: args
    })
  },
  // 消息详情
  mobilemsggetById(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/getById/' + args,
      method: 'get'
    })
  },
  // 设置消息已读
  mobilemsgreadById(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/readById/' + args,
      method: 'get'
    })
  },
  // 消息删除
  mobilemsgdeleteById(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/receive/deleteById/' + args,
      method: 'get'
    })
  },
  // 未读消息数
  mobilemsgcountUnread(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/countUnread',
      method: 'get',
      params: args
    })
  },
  // 全部已读
  mobilemsgreadAll() {
    return Axios({
      url: requestPrefix.projectUrl + '/sys/msg/readAll',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/noticemanagement/index.js